import { useCallback, useEffect } from "react";
import { Button, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AddPatient from "../../../../Img/add-patient.png";
import { clearData } from "redux/reducers/SearchPanel/globalSearch.slice";
import DefaultMalePatientImg from "../../../../Img/default-male-patient-img.png";
import DefaultFemalePatientImg from "../../../../Img/default-female-patient-img.png";
import {
  setSelectedPatient,
  setSelectedModuleTab,
} from "redux/reducers/common.slice";
import {
  setActivePatient,
  getDashboardPatientInfo,
  setSelectedPatientJourneyInfo,
} from "redux/reducers/Dashboard/dashboard.slice";

function PatientListCycles() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { selectedLocation } = useSelector(({ role }) => role);
  const { activePatient, patientObject } = useSelector(
    ({ dashboard }) => dashboard
  );

  useEffect(() => {
    // const slider = document.querySelector(".patient_list");
    // if (!slider) return;

    // let isDown = false;
    // let startX;
    // let scrollLeft;

    // const handleMouseDown = (e) => {
    //   isDown = true;
    //   slider.classList.add("active");
    //   startX = e.pageX - slider.offsetLeft;
    //   scrollLeft = slider.scrollLeft;
    // };

    // const handleMouseLeave = () => {
    //   isDown = false;
    //   slider.classList.remove("active");
    // };

    // const handleMouseUp = () => {
    //   isDown = false;
    //   slider.classList.remove("active");
    // };

    // const handleMouseMove = (e) => {
    //   if (!isDown) return;
    //   e.preventDefault();
    //   const x = e.pageX - slider.offsetLeft;
    //   const walk = (x - startX) * 1; // scroll speed
    //   slider.scrollLeft = scrollLeft - walk;
    // };

    // slider.addEventListener("mousedown", handleMouseDown);
    // slider.addEventListener("mouseleave", handleMouseLeave);
    // slider.addEventListener("mouseup", handleMouseUp);
    // slider.addEventListener("mousemove", handleMouseMove);

    // return () => {
    //   slider.removeEventListener("mousedown", handleMouseDown);
    //   slider.removeEventListener("mouseleave", handleMouseLeave);
    //   slider.removeEventListener("mouseup", handleMouseUp);
    //   slider.removeEventListener("mousemove", handleMouseMove);
    // };

    const slider = document.querySelector(".patient_list");
    if (!slider) return;

    const handleWheel = (e) => {
      e.preventDefault();
      slider.scrollLeft += e.deltaY;
    };

    slider.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      slider.removeEventListener("wheel", handleWheel);
    };
  }, []);

  const handleSelectPatient = useCallback(
    (patient) => {
      if (patient) {
        const payload = {
          location_id: selectedLocation,
          patient_reg_id: patient._id,
        };

        dispatch(getDashboardPatientInfo(payload));
        dispatch(setActivePatient(patient));
        dispatch(setSelectedPatientJourneyInfo({}));
      }
    },
    [dispatch, selectedLocation]
  );

  const onRedirectForCreatePatient = () => {
    // clear all existing data which have patient
    dispatch(setSelectedPatient({}));
    dispatch(clearData());

    dispatch(setActivePatient({}));

    navigate("/patient-registration");

    dispatch(setSelectedModuleTab("2"));
  };

  return (
    <div className="patient-list-cycles">
      <h3 class="mb-3">
        Ongoing Cycles ({patientObject?.dashboardPatientListCount})
      </h3>

      <Row className="patient-row">
        <Button className="add-patient-btn">
          <div className="icon">
            <img src={AddPatient} alt="" onClick={onRedirectForCreatePatient} />
          </div>

          <span>Add Patient</span>
        </Button>

        <div className="patient_list">
          {patientObject?.dashboardPatientList?.map((patient, index) => {
            const {
              _id,
              patient_photo,
              patient_full_name,
              patient_salutation,
            } = patient;

            return (
              <Button
                key={index}
                className={activePatient?._id === _id ? "active" : ""}
                onClick={() => handleSelectPatient(patient)}
              >
                <div className="icon">
                  <img
                    src={
                      patient_photo
                        ? `${process.env.REACT_APP_SOCKET_URL}${patient_photo}`
                        : patient_salutation === "Mr."
                        ? DefaultMalePatientImg
                        : DefaultFemalePatientImg
                    }
                    alt=""
                  />
                </div>
                <span>{patient_full_name}</span>
              </Button>
            );
          })}
        </div>
      </Row>
    </div>
  );
}

export default PatientListCycles;
